import axios, { AxiosInstance } from 'axios';
import { merge } from '../utility/common';
import { DEFAULT_TIMEOUTS, HTTP_METHODS } from './api.constants';
import {
  axiosRejectedResponseInterceptor,
  axiosSuccessResponseInterceptor
} from './api.error.helpers';

let amazonAwsRequestInstance: AxiosInstance;

const AWS_BASE_URL = 'https://ytszincu2a.execute-api.us-east-1.amazonaws.com';

/** Initialize API for the amazonaws endpoint. */
export function initAmazonAwsApi() {
  amazonAwsRequestInstance = axios.create({
    // @ts-ignore investigate if environmentUrls needs to be in ApiInstanceConfiguration
    baseURL: AWS_BASE_URL,
    method: HTTP_METHODS.GET,
    timeout: DEFAULT_TIMEOUTS.SERVICES
  });

  amazonAwsRequestInstance.interceptors.response.use(
    axiosSuccessResponseInterceptor,
    axiosRejectedResponseInterceptor
  );
}

export function retrieveAmazonAwsData<ResponseType>({
  headers = {},
  path
}: {
  headers?: {};
  path: string;
}): Promise<ResponseType> {
  return amazonAwsRequestInstance.request<any, ResponseType>({
    headers: merge(
      {},
      amazonAwsRequestInstance.defaults.headers.common,
      headers
    ),
    url: `/${path}`
  });
}
